import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const getDistributorHistory = (
  {
    currentPage,
    pageSize,
    isLive,
    params = {}
  }: {
    currentPage: number,
    pageSize: number,
    isLive: boolean,
    params: Record<string, string | number | boolean>
  }
) => {
  const queryParams = {
    page: currentPage,
    page_size: pageSize,
    is_live: isLive,
    ...params
  };

  return axiosPrivate.get(`/bills/api/v1/distributor/paid-history/`, { params: queryParams });
};